export default __webpack_public_path__ + "static/media/Israel_Hayom.e2e0c301.svg";